module.exports = __webpack_public_path__ + "img/export.95d41dc8.svg";